// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const useExportLogsApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getExportLogs = () => request("GET", `${API_STAGES_URL}/v1/exportlogs`)

  return [
    requestState,
    payload,
    error,
    {
      getExportLogs,
    },
  ]
}

export default useExportLogsApi
